import { ArrowRight, BookLock, Settings2 } from "lucide-react";
import { Button } from "./ui/button";
import Image from "next/image";

const Features03Page = () => {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="w-full max-w-screen-lg mx-auto py-12 px-6">
        <div className="mt-8 grid sm:grid-cols-2 md:grid-cols-5 lg:grid-cols-3 gap-6">
          {/* Card 1 */}
          <div className="bg-muted rounded-xl pt-6 md:pt-8 pb-6 px-6 col-span-1 md:col-span-2 lg:col-span-1">
            <div className="md:hidden mb-6 aspect-video w-full bg-background border rounded-xl"></div>
            <span className="text-2xl font-bold tracking-tight">Manage Documentation</span>
            <ul className="mt-6 space-y-4">
              <li>
                <div className="flex items-start gap-3">
                  <Settings2 className="shrink-0" />
                  <p className="-mt-0.5">Effortlessly create, edit, and manage documentation with an intuitive interface.</p>
                </div>
              </li>
              <li>
                <div className="flex items-start gap-3">
                  <BookLock className="shrink-0" />
                  <p className="-mt-0.5">Secure and organize knowledge for easy access across teams.</p>
                </div>
              </li>
            </ul>
            <Button className="mt-12 w-full">Explore Docloo <ArrowRight /></Button>
          </div>
          {/* Media 1 Desktop */}
          <div className="hidden md:block border border-border/80 bg-muted rounded-xl col-span-1 md:col-span-3 lg:col-span-2">
            <Image 
              src="https://img.freepik.com/free-photo/business-plan-concept_23-2148356255.jpg" 
              alt="Documentation Management" 
              width={800} 
              height={450} 
              className="w-full h-auto rounded-xl" 
            />
          </div>
          {/* Media 2 Desktop */}
          <div className="hidden md:block border border-border/80 bg-muted rounded-xl col-span-1 md:col-span-3 lg:col-span-2">
            <Image 
              src="https://img.freepik.com/free-photo/coworking-team-collaborating-laptops_197531-3848.jpg" 
              alt="Job Management" 
              width={800} 
              height={450} 
              className="w-full h-auto rounded-xl" 
            />
          </div>
          {/* Card 2 */}
          <div className="bg-muted rounded-xl pt-6 md:pt-8 pb-6 px-6 col-span-1 md:col-span-2 lg:col-span-1">
            <div className="md:hidden mb-6 aspect-video w-full bg-background border rounded-xl"></div>
            <span className="text-2xl font-bold tracking-tight">Simplify Job Management</span>
            <ul className="mt-6 space-y-4">
              <li>
                <div className="flex items-start gap-3">
                  <Settings2 className="shrink-0" />
                  <p className="-mt-0.5">Post jobs, manage applications, and streamline hiring effortlessly.</p>
                </div>
              </li>
              <li>
                <div className="flex items-start gap-3">
                  <BookLock className="shrink-0" />
                  <p className="-mt-0.5">Automate workflows to keep your hiring process smooth and efficient.</p>
                </div>
              </li>
            </ul>
            <Button className="mt-12 w-full">Start Managing Jobs <ArrowRight /></Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Features03Page;
